// A wrapper is considered "split" if any of these exist inside
const SPLIT_SELECTORS = '.bc-blade-title__line-wrapper, .line, .word, .char';

// Kill only ScrollTriggers tied to/inside this element
function killTriggersFor(el) {
	if (!window.ScrollTrigger || !ScrollTrigger.getAll) return;
	ScrollTrigger.getAll().forEach(st => {
		const trg = st.vars && st.vars.trigger;
		const trgEl = typeof trg === 'string' ? document.querySelector(trg) : trg;
		if (trgEl && (trgEl === el || el.contains(trgEl))) st.kill();
	});
}

// Put a single element back to pristine markup (no wrappers, no transforms)
function makePristine(el) {
	// If we previously cached a clean version, restore it.
	if (el.dataset.nbOriginalHtml) {
		el.innerHTML = el.dataset.nbOriginalHtml;
	} else {
		// If already split, unwrap safely by falling back to plain text
		if (el.querySelector(SPLIT_SELECTORS)) {
			el.textContent = el.textContent;
		}
		// Cache the pristine HTML now (either real original or text-only fallback)
		el.dataset.nbOriginalHtml = el.innerHTML;
	}

	// Remove any inline transforms that could linger
	el.querySelectorAll('*').forEach(n => {
		n.style.removeProperty('transform');
		n.style.removeProperty('translate');
		n.style.removeProperty('rotate');
		n.style.removeProperty('scale');
	});

	el.classList.remove('bc-blade-title__inner--to-hide');
}

// Debounce helper
function debounce(fn, wait) {
	let t; return function () { clearTimeout(t); t = setTimeout(fn, wait); };
}

// ---- Lazy setup that waits for ScrollTrigger -------------------------------

(function initWhenScrollTriggerReady() {
	const maxWait = 10000;     // 10s safety cap
	const interval = 100;      // check every 100ms
	const start = Date.now();

	const tick = () => {
		if (window.ScrollTrigger) {
			setupBladeTitleSafety();   // do the real setup once ST exists
			return;
		}
		if (Date.now() - start >= maxWait) {
			// Safety bail-out (do nothing if ScrollTrigger never shows up)
			// console.warn('ScrollTrigger not found within 10s; blade title init skipped.');
			return;
		}
		setTimeout(tick, interval);
	};

	tick();
})();

function setupBladeTitleSafety() {
	// Capture original initializer *now* (after libs likely loaded)
	const _blade_title_original = window.blade_title || function () { /* no-op if vendor missing */ };

	// Our safe initializer: reset -> original -> refresh
	function nbInitBladeTitles() {
		const inners = document.querySelectorAll('.bc-blade-title__inner');
		if (!inners.length) return;

		inners.forEach(el => {
			killTriggersFor(el);
			makePristine(el);
		});

		// Re-run the vendor initializer (will split per data-type)
		_blade_title_original();

		// Recalculate ScrollTrigger positions
		if (window.ScrollTrigger && ScrollTrigger.refresh) {
			ScrollTrigger.refresh();
		}
	}

	// Public hook for programmatic changes
	window.nbReinitBladeTitles = nbInitBladeTitles;

	// Resize handling (debounced)
	window.addEventListener('resize', debounce(nbInitBladeTitles, 150));

	// Also observe element size changes (tabs/accordions/column width changes)
	if ('ResizeObserver' in window) {
		const ro = new ResizeObserver(debounce(nbInitBladeTitles, 150));
		document.querySelectorAll('.bc-blade-title__inner').forEach(el => ro.observe(el));
	}

	// If the vendor script already ran before we patched it, call ours once
	// to normalize everything and prevent nested wrappers from this point on.
	// nbInitBladeTitles();
}
